module.exports = __webpack_public_path__ + "static/media/location.2aec45b5.svg";